import React, { useState, useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import countryList from "react-select-country-list";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import SubmitIcon from "../../assets/contactus/submit.svg";
import { useNavigate } from "react-router";
import { Controller } from "react-hook-form";
// validation
import { useForm } from "react-hook-form";
import { parsePhoneNumberFromString } from "libphonenumber-js";

// API
import { ApiHelper } from "../../utilFunctions/utilfunction";
const Profile = () => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [flashmessage, setFlashmessage] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // For recaptcha
  const [recaptcha, setRecaptcha] = useState(true);
  const initialEmailRef = useRef(null);

  // For validation
  const defaultValues = {
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    country_code: "",
    country_name: " ",
    user_type: " ",
    fb_user: "",
    insta_user: "",
  };
  const options = countryList().getData();
  const [messagess, setMessagess] = useState("");
  const [isError, setIsError] = useState("");
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("access_token");
      if (!token) return;

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      try {
        const response = await ApiHelper("/profile", {}, "GET", headers);
        if (response?.status === true || response?.code === 200) {
          const user = response.data;
          reset({
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            phone_number: user.phone_number,
            country_code: user.country_code || "",
            country_name: user.country_name || "",
            user_type: user.user_type || "",
            fb_user: user.fb_user || "",
            insta_user: user.insta_user || "",
          });
          initialEmailRef.current = user.email;
        } else {
          const errorMsg = response?.message || "Profile fetch failed.";

          setIsError(true);
          setMessagess(errorMsg);

          setFlashmessage(true);
          setTimeout(() => {
            setFlashmessage(false);
            setMessagess("");
            setIsError(false);
          }, 10000);
        }
      } catch (error) {
        setIsError(true);
        setMessagess("Something went wrong");
        setFlashmessage(true);
        setTimeout(() => {
          setFlashmessage(false);
          setMessagess("");
          setIsError(false);
        }, 10000);
      }
    };

    fetchProfile();
  }, []);

  // console.log(messagess);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
    getValues,
    setValue,
    control,
    watch,
  } = useForm({
    defaultValues,
  });
  const watchedEmail = watch("email");
  const accountType = watch("user_type");
  const [selectedCountry, setSelectedCountry] = useState("gb");
  const [isRecaptchaError, setIsRecaptchaError] = useState(false);
  const watchedValues = watch();
  const initialValuesRef = useRef({
    first_name: defaultValues.first_name,
    last_name: defaultValues.last_name,
    email: defaultValues.email,
    phone_number: defaultValues.phone_number,
    country_code: defaultValues.country_code,
    country_name: defaultValues.country_name,
    user_type: defaultValues.user_type,
    fb_user: defaultValues.fb_user,
    insta_user: defaultValues.insta_user,
    // Add all other fields you want to track except `email`
  });
  const isOtherFieldChanged = Object.entries(initialValuesRef.current).some(
    ([key, value]) => watchedValues[key] !== value
  );
  const handleVerifyEmail = async () => {
    const emailValue = getValues("email"); // Get current email field value
    const token = localStorage.getItem("access_token");

    if (!token || !emailValue) return;

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const reqToSend = {
      new_email: emailValue,
    };

    try {
      const response = await ApiHelper(
        "/email/update/request",
        reqToSend,
        "POST",
        headers
      );

      if (response?.code === 200 && response?.status === true) {
        setIsError(false);
        setMessagess(response.message || "Verification email sent.");
        setFlashmessage(true);
        setTimeout(() => {
          navigate("/two-factor-authentication", {
            state: { email: emailValue },
          });
        }, 1000);
      } else {
        setIsError(true);
        setMessagess(response?.message || "Failed to send verification email.");
        setFlashmessage(true);
      }
    } catch (error) {
      setIsError(true);
      setMessagess("Something went wrong.");
      setFlashmessage(true);
    }

    // Auto-clear flash message
    setTimeout(() => {
      setFlashmessage(false);
      setMessagess("");
      setIsError(false);
    }, 10000);
  };

  const Submit = async (event) => {
    if (recaptcha) {

      setIsRecaptchaError(true);
      return;
    } else {
      setIsRecaptchaError(false);
    }
    setLoading(true);
    const token = localStorage.getItem("access_token");
    console.log(token, "Token");
    if (!token) return;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const countryOption = options.find(
      (opt) => opt.value === event.country_code
    );
    const countryName = countryOption ? countryOption.label : "";

    const reqToSend = {
      first_name: event.first_name,
      last_name: event.last_name,
      email: event.email,
      phone_number: event.phone_number,
      country_code: event.country_code,
      country_name: countryName,
      user_type: event.user_type,
      fb_user: event.fb_user,
      insta_user: event.insta_user,

    };

    try {
      const response = await ApiHelper(
        "/profile-update",
        reqToSend,
        "POST",
        headers
      );
      if (response?.code === 200 && response?.status === true) {
        setIsError(false);
        setFlashmessage(true);
        setMessagess(response.message || "Profile updated successfully.");


        reset({
          first_name: event.first_name,
          last_name: event.last_name,
          email: event.email,
          phone_number: event.phone_number,
          country_code: event.country_code,
          user_type: event.user_type,
          country_name: event.country_name,
          fb_user: event.fb_user,
          insta_user: event.insta_user,
        });
      } else {
        const errorMsg = response?.message || "Update profile failed.";
        setIsError(true);
        setMessagess(errorMsg);
        setFlashmessage(true);
      }
    } catch (error) {
      setIsError(true);
      setMessagess("Something went wrong");
      setFlashmessage(true);
    } finally {
      setLoading(false);
    }

    window.grecaptcha.reset();
    setRecaptcha(true);

    setTimeout(() => {
      setFlashmessage(false);
      setMessagess("");
      setIsError(false);
      reset();
    }, 5000);
  };

  const handleChange = (value) => {
    if (value) {
      setRecaptcha(false);
      setIsRecaptchaError(false);
    } else {
      setRecaptcha(false);
    }
  };

  return (
    <section className="contactus p-navbar">
      <div className="common_form container pt-5 ps-lg-0 pe-lg-0">
        <h4 className="fw-bold text-uppercase fs-18">Profile</h4>

        {/*** Form ***/}
        <div className="d-flex justify-content-center">
          <form
            className="form pt-4"
            onSubmit={handleSubmit(Submit)}
            style={{ width: "100%" }}
          >
            <div className="row d-flex flex-wrap justify-content-between">
              <div className="col-12 col-lg-6 pe-lg-4">
                <div className="textOnInput">
                  <input
                    className="form-control"
                    type="text"
                    {...register("first_name", {
                      required: "First Name is required",
                    })}
                    onKeyUp={() => {
                      trigger("first_name");
                    }}
                  />
                  {errors.first_name && (
                    <p className="position-absolute text-danger">
                      {errors.first_name.message}
                    </p>
                  )}
                  <label
                    htmlFor="inputText"
                    style={{ backgroundColor: "white" }}
                  >
                    FirstName*
                  </label>
                </div>
                <div className="textOnInput">
                  <input
                    className="form-control"
                    type="text"
                    {...register("last_name", { required: "Last Name is required" })}
                    onKeyUp={() => {
                      trigger("last_name");
                    }}
                  />
                  {errors.last_name && (
                    <p className="position-absolute text-danger">
                      {errors.last_name.message}
                    </p>
                  )}
                  <label
                    htmlFor="inputText"
                    style={{ backgroundColor: "white" }}
                  >
                    LastName*
                  </label>
                </div>
                <div className="d-flex align-items-start gap-3">
                  {/* Email Input */}
                  <div className="textOnInput">
                    <input
                      className="form-control"
                      type="text"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid Email Address",
                        },
                      })}
                      onKeyUp={() => {
                        trigger("email");
                      }}
                    />
                    {errors.email && (
                      <p className="position-absolute text-danger">
                        {errors.email.message}
                      </p>
                    )}
                    <label
                      htmlFor="inputText"
                      style={{ backgroundColor: "white" }}
                    >
                      Email Address*
                    </label>
                  </div>

                  {/* Verify Button */}
                  <div>
                    <button
                      type="button"
                      onClick={handleVerifyEmail}
                      style={{ height: "40px" }}
                      className="fw-600 btn hover2"
                      disabled={
                        !watchedEmail ||
                        watchedEmail === initialEmailRef.current
                      }
                    >
                      Verify
                    </button>
                  </div>
                </div>
                <div className="textOnInput"
                  style={{ backgroundColor: "white" }}>
                  <Controller
                    name="country_code"
                    control={control}
                    rules={{ required: "Country is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={options}
                        isSearchable
                        placeholder=""
                        isClearable
                        menuPortalTarget={document.body}
                        value={
                          options.find(
                            (opt) => opt.value === field.value
                          ) || null
                        } 
                        onChange={(selectedOption) => {
                          field.onChange(
                            selectedOption ? selectedOption.value : ""
                          );
                          if (selectedOption?.value) {
                            const iso =
                              selectedOption.value.toUpperCase();
                            setSelectedCountry(iso.toLowerCase()); 
                             setValue("phone_number", "");
    
                          }
                        }}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            backgroundColor: "transparent",
                            border: state.isFocused ? "1px solid black" : "1px solid #8692A6",
                            boxShadow: state.isFocused && "none",
                            "&:hover": {
                              border: "1px solid black",
                            },
                            borderRadius: "0.25rem",
                            minHeight: "38px",
                            fontSize: "15px",

                          }),
                          valueContainer: (base) => ({
                            ...base,
                            backgroundColor: "transparent !important",
                            padding: "0 8px",
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: "#000000", 
                            fontSize: "15px",
                            marginLeft: "6px",
                            backgroundColor: "transparent !important",
                          }),
                          input: (base) => ({
                            ...base,
                            fontSize: "15px",
                            color: "#000000",
                            backgroundColor: "transparent !important",
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}

                      />
                    )}
                  />
                  {errors.country_code && (
                    <p className="position-absolute text-danger">
                      {errors.country_code.message}
                    </p>
                  )}
                  <label
                    htmlFor="inputText"
                    style={{ backgroundColor: "white" }}
                  >
                    Country*
                  </label>
                </div>
                <div className="textOnInput"
                  style={{ backgroundColor: "white" }}
                >
                  <Controller
                    name="phone_number"
                    control={control}
                    
                    rules={{
                      validate: (value) => {
                        if (!value || value.trim() === "") {
                          return "Phone number is required";
                        }
                        const phoneNumber = parsePhoneNumberFromString(value);
                        if (!phoneNumber || !phoneNumber.isValid()) {
                          return "Invalid phone number";
                        }
                        return true;
                      },
                    }}
                    render={({ field }) => {
                      const formatted = field.value ?? "";
                      const rawForPhoneInput = formatted.replace(/\D/g, "");

                      return (
                        <PhoneInput
                          country={selectedCountry}
                          enableSearch
                          inputClass="form-control phone-custom-input"
                          buttonClass="phone-dropdown-btn"
                          dropdownClass="phone-dropdown-menu"
                          value={rawForPhoneInput}
                          onChange={(value, country) => {
                            const dialDigits = country?.dialCode || "";
                            let localDigits = value.startsWith(dialDigits)
                              ? value.slice(dialDigits.length)
                              : value;

                            const maxDigits =
                              (country?.format?.match(/\./g) || []).length || 15;

                            localDigits = localDigits.replace(/\D/g, "").slice(0, maxDigits);

                            const formattedValue = `+${dialDigits}${localDigits ? " " + localDigits : ""
                              }`;

                            field.onChange(formattedValue.trim());
                          }}
                        />
                      );
                    }}
                  />

                  {errors.phone_number && (
                    <p className="position-absolute text-danger">
                      {errors.phone_number.message}
                    </p>
                  )}
                  <label
                    htmlFor="inputText"
                    style={{ backgroundColor: "white" }}
                  >
                    Phone Number*
                  </label>
                </div>
               
               

              </div>
                <div className="col-12 col-lg-6 pe-lg-4">
              <div className="textOnInput">
                  <input
                    className="form-control"
                    type="text"
                    {...register("fb_user",{
                      pattern: {
                        value: /^(?!.*\.\.)(?!.*\.$)(?!^\.)[a-zA-Z0-9._]{1,30}$/,
                        message: "Invalid Facebook username",
                      },
                    })}
                    onKeyUp={() => {
                      trigger("fb_user");
                    }}
                  />
                  {errors.fb_user && (
                    <p className="position-absolute text-danger">
                      {errors.fb_user.message}
                    </p>
                  )}
                  <label
                    htmlFor="inputText"
                    style={{ backgroundColor: "white" }}
                  >
                    Facebook Username
                  </label>
                </div>
                <div className="textOnInput">
                  <input
                    className="form-control"
                    type="text"
                    {...register("insta_user",{ required: "Instagram Username is required" , pattern: {
                      value: /^(?!.*\.\.)(?!.*\.$)(?!^\.)[a-zA-Z0-9._]{1,30}$/,
                      message: "Invalid Instagram username",
                    },})}
                    onKeyUp={() => {
                      trigger("insta_user");
                    }}
                  />
                  {errors.insta_user && (
                    <p className="position-absolute text-danger">
                      {errors.insta_user.message}
                    </p>
                  )}
                  <label
                    htmlFor="inputText"
                    style={{ backgroundColor: "white" }}
                  >
                    Instagram Username*
                  </label>
                </div>
                <div className="textOnInput">
                  <input
                    className="form-control"
                    type="text"
                    disabled
                    value={
                      getValues("user_type") === "1"
                        ? "Watch Collector"
                        : getValues("user_type") === "2"
                          ? "Watch Retailer"
                          : ""
                    }
                    readOnly
                  />
                  {errors.user_type && (
                    <p className="position-absolute text-danger">
                      {errors.user_type.message}
                    </p>
                  )}
                  <label
                    htmlFor="inputText"
                    style={{ backgroundColor: "white" }}
                  >
                    Account Type*
                  </label>
                </div>
              <ReCAPTCHA
                id="recaptcha"
                sitekey={siteKey || ""}
                onChange={handleChange}
              />
              {isRecaptchaError && recaptcha && (
                <span className="text-danger d-block" style={{ fontSize: 16 }}>
                  Please verify the captcha.
                </span>
              )}
               <div className="d-flex flex-wrap mt-md-5 mt-lg-4 align-items-center gap-4">
                <button
                  type="button"
                  className="fw-600 btn cancel_button "
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="fw-600 btn hover2 submit_button"
                  disabled={watchedValues.email !== initialEmailRef.current}
                >
                  Submit
                </button>
                {loading && (
                  <div
                    className="spinner-border text-light align-self-center"
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                      borderWidth: "0.2em",
                      borderColor: "#ccc", // All borders
                      borderTopColor: "#333", // Spinner color
                    }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
                {flashmessage && messagess && (
                  <div
                    className={`d-flex mt-1 align-items-center pt-2 pt-sm-0 ${isError ? "text-danger" : "text-black"
                      }`}
                  >
                    {!isError && (
                      <img className="ps-sm-4 pe-2" src={SubmitIcon} alt="" />
                    )}
                    <span className="fs-5">{messagess}</span>
                  </div>
                )}
              </div>
              </div>

             
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Profile;
